package com.essntl.features.service.ui.allservice

import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.service.domain.model.service.ServiceFilterOptions
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.tag.domain.model.TagModel

data class AllServiceState(
    val selectedCategoryId: String? = null,
    val selectedServiceId: String? = null,

    val getAllCategory: State<List<CategoryModel>> = State(),
    val getAllTag: State<List<TagModel>> = State(),
    val getAllArea: State<List<AreaModel>> = State(),
    val getCurrentProfile: State<ProfileModel> = State(),
    val getAllService: PaginationState<ServiceModel> = PaginationState(),
    val getAllServiceOrganization: State<List<ServiceModel>> = State(),
    val getAllServiceCount: State<Long> = State(),
    val filterOptions: ServiceFilterOptions = ServiceFilterOptions(),
    val deleteServiceMap: Map<String, State<Unit>> = emptyMap(),
) {
    fun setDeleteServiceState(serviceId: String, deleteServiceState: State<Unit>): AllServiceState {
        return copy(
            deleteServiceMap = deleteServiceMap.toMutableMap().apply {
                put(
                    serviceId,
                    deleteServiceState,
                )
            },
        )
    }

    fun removeDeleteServiceState(serviceId: String): AllServiceState {
        return copy(
            deleteServiceMap = deleteServiceMap.toMutableMap().apply {
                remove(serviceId)
            },
        )
    }
}